module.exports = "/virtual-football-league/img/amblems/right/logos/VALENCIA.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/VALENCIA.png
// module id = 2233
// module chunks = 4